<template>
  <CContainer fluid>
    <CCard class="mb-3 filters-card">
      <CCardBody>
        <div class="filters-header">
          <div>
            <span class="filters-kicker">Panel de consulta</span>
            <h5>Filtros de mercadeo</h5>
          </div>
          <div class="filters-range">
            <i class="bi bi-calendar3"></i>
            <span>{{ moment(startDate).format("DD/MM/YYYY") || 'Fecha inicial' }} - {{ moment(endDate).format("DD/MM/YYYY") || 'Fecha final' }}</span>
          </div>
        </div>

        <CRow class="filters-row align-items-end">
          <CCol lg="3" md="6" class="filter-col">
            <div class="form-group filter-field">
              <label>
                <i class="bi bi-calendar-event"></i>
                <span>Fecha Inicial</span>
              </label>
              <DatePicker
                type="date"
                v-model="startDate" 
                class="filter-control" 
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa" />
            </div>
          </CCol>
          <CCol lg="3" md="6" class="filter-col">
            <div class="form-group filter-field">
              <label>
                <i class="bi bi-calendar-check"></i>
                <span>Fecha Final</span>
              </label>
              <DatePicker 
                type="date"
                v-model="endDate" 
                class="filter-control" 
                value-type="YYYY-MM-DD"
                format="DD/MM/YYYY"
                placeholder="dd/mm/aaaa" />
            </div>
          </CCol>
          <CCol lg="3" md="6" class="filter-col">
            <CSelect
              class="filter-select"
              label="Grupo Comercial"
              :options="groupOptions"
              :value.sync="selectedGroup"
            />
          </CCol>
          <CCol lg="3" md="6" class="filter-col">
            <CSelect
              class="filter-select"
              label="Comercial"
              :options="sellerOptions"
              :value.sync="selectedSeller"
            />
          </CCol>
        </CRow>
        <div class="filters-actions">
          <CButton 
            color="dark" 
            class="query-button" 
            @click="fetchCountsWithFilters">
            <span>
              <i class="bi bi-search"></i>
            </span>
            <span>Consultar</span>
          </CButton>
        </div>
      </CCardBody>
    </CCard>

    <!-- <div class="mb-3 d-flex justify-content-start align-items-stretch">
      <div class="tile small bg-s3turquoise mr-2 info-tile">
        <i class="bi  h3 mb-1"></i>
        <div class="h4 mb-1">{{  }}</div>
        <span>Prospectos</span>
      </div>
      <div class="tile small bg-s3lime mr-2 info-tile">
        <i class="bi  h3 mb-1"></i>
        <div class="h4 mb-1">{{  }}</div>
        <span>Oportunidades</span>
      </div>
      <div class="tile small bg-s3taillight mr-2 info-tile">
        <i class="bi bi-eye h3 mb-1"></i>
        <div class="h4 mb-1">{{  }}</div>
        <span>Visitas (periodo)</span>
      </div>
    </div> -->


    <CRow>
      <CCol lg="3">
        <CWidgetProgressIcon
            color="s3turquoise"
            text="Prospectos Periodo"
            :value="0"
            :header="`${prospectsCount}`">
            <template #progress>
              &nbsp;
            </template>
            <span class="small text-s3turquoise mr-2">{{ prospectsCount }}</span>
            <i class="bi bi-person-exclamation text-s3turquoise h1"></i>
        </CWidgetProgressIcon>                                
      </CCol>
      <CCol lg="3">
        <CWidgetProgressIcon
            color="s3turquoise"
            text="Oportunidades"
            :value="0"
            :header="`$${formatter.format(opportunitiesValues, 2)}M`">
            <template #progress>
              &nbsp;
            </template>
            <span class="small text-s3lime mr-2">{{ opportunitiesCount }}</span>
            <i class="bi bi-graph-up-arrow text-s3lime h1"></i>
        </CWidgetProgressIcon>                                
      </CCol>
      <CCol lg="3">
        <CWidgetProgressIcon
            color="s3turquoise"
            text="Visitas Periodo"
            :value="0"
            :header="`${visitsCount}`">
            <template #progress>
              &nbsp;
            </template>
            <span class="small text-s3turquoise mr-2">{{ visitsCount }}</span>
            <i class="bi bi-person-exclamation text-s3turquoise h1"></i>
        </CWidgetProgressIcon>                                
      </CCol>
    </CRow>

    <CRow class="mb-3 charts-row">
      <CCol lg="4" class="mb-3 mb-lg-0">
        <CCard class="chart-card h-100">
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <div>
              <strong>Prospectos por comercial</strong>
              <small class="text-muted d-block">Distribuci&oacute;n del periodo consultado</small>
            </div>
            <CBadge color="light" class="text-dark">{{ prospectsCount }} prospectos</CBadge>
          </CCardHeader>
          <CCardBody>
            <div v-if="loadingProspectsBySeller" class="chart-state">
              <CSpinner color="info" size="sm" class="mr-2" />
              <span>Cargando gr&aacute;fico...</span>
            </div>
            <div v-else-if="!prospectsBySeller.length" class="chart-state text-muted">
              No hay prospectos para graficar con los filtros seleccionados.
            </div>
            <div v-show="!loadingProspectsBySeller && prospectsBySeller.length" class="chart-shell">
              <canvas ref="prospectsBySellerChart"></canvas>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol lg="4" class="mb-3 mb-lg-0">
        <CCard class="chart-card h-100">
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <div>
              <strong>Oportunidades por comercial</strong>
              <small class="text-muted d-block">Distribuci&oacute;n del periodo consultado</small>
            </div>
            <CBadge color="light" class="text-dark">{{ opportunitiesCount }} oportunidades</CBadge>
          </CCardHeader>
          <CCardBody>
            <div v-if="loadingOpportunitiesBySeller" class="chart-state">
              <CSpinner color="success" size="sm" class="mr-2" />
              <span>Cargando gr&aacute;fico...</span>
            </div>
            <div v-else-if="!opportunitiesBySeller.length" class="chart-state text-muted">
              No hay oportunidades para graficar con los filtros seleccionados.
            </div>
            <div v-show="!loadingOpportunitiesBySeller && opportunitiesBySeller.length" class="chart-shell">
              <canvas ref="opportunitiesBySellerChart"></canvas>
            </div>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol lg="4" class="mb-3 mb-lg-0">
        <CCard class="chart-card h-100">
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <div>
              <strong>Funnel de ventas</strong>
              <small class="text-muted d-block">Oportunidades por fase de venta</small>
            </div>
            <CBadge color="light" class="text-dark">{{ opportunitiesCount }} oportunidades</CBadge>
          </CCardHeader>
          <CCardBody>
            <div v-if="loadingSalesFunnel" class="chart-state">
              <CSpinner color="primary" size="sm" class="mr-2" />
              <span>Cargando funnel...</span>
            </div>
            <div v-else-if="!salesFunnelData.length" class="chart-state text-muted">
              No hay fases de venta para graficar con los filtros seleccionados.
            </div>
            <div v-show="!loadingSalesFunnel && salesFunnelData.length" class="funnel-shell">
              <canvas ref="salesFunnelChart"></canvas>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
  import DatePicker from "vue2-datepicker";
  import moment from "moment";
  import { Chart, registerables } from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { FunnelController, TrapezoidElement } from "chartjs-chart-funnel";

  import { formatter } from "@/general";
  import { 
    dataProspectos,
    dataOportunidades 
  } from "@/apis/marketing";

  Chart.register(...registerables);
  Chart.register(FunnelController, TrapezoidElement);

  export default {
    name: "MarketingMenu",
    components: {
      DatePicker,
    },
    data() {
      return {
        formatter,
        startDate: "",
        endDate: "",
        prospectsCount: 0,
        opportunitiesCount: 0,
        opportunitiesValues: 0,
        visitsCount: 0,
        groupOptions: [{ value: '', label: 'Todos' }],
        sellerOptions: [{ value: '', label: 'Todos' }],
        salesPhaseOptions: [],
        selectedGroup: '',
        selectedSeller: '',
        loadingProspectsBySeller: false,
        loadingOpportunitiesBySeller: false,
        loadingSalesFunnel: false,
        prospectsBySeller: [],
        opportunitiesBySeller: [],
        salesFunnelData: [],
        prospectsBySellerChart: null,
        opportunitiesBySellerChart: null,
        salesFunnelChart: null,
        chartColors: [
          "#0ea5a5",
          "#84cc16",
          "#64748b",
          "#3b82f6",
          "#f97316",
          "#ec4899",
          "#8b5cf6",
          "#14b8a6",
          "#eab308",
          "#ef4444"
        ]
      }
    },
    methods: {
      moment,
      async fetchCounts(useFilters = false) {
        try {
          const filtersCommon = this.getFiltersCommon(useFilters);

          // Prospects
          try {
            const parameters = { 
              "Fecha_Inicial": this.startDate,
              "Fecha_Final": this.endDate,
              "Tipo_Reporte": "RT"
            };
            const { Cantidad } = await dataProspectos(this, 1, "", parameters);

            this.prospectsCount = Cantidad ? Cantidad : 0;
          } catch (e) {
            console.error('Error cargando prospectos', e);
          }

          // Opportunities
          try {
            const parameters = { 
              "Fecha_Inicial": this.startDate,
              "Fecha_Final": this.endDate,
              "Tipo_Reporte": "RT"
            };
            const { Cantidad, Valores } = await dataOportunidades(this, 1, "", parameters);

            this.opportunitiesCount = Cantidad ? Cantidad : 0;
            this.opportunitiesValues = Valores ? (Valores / 1000000) : 0;
          } catch (e) {
            console.error('Error cargando oportunidades', e);
          }

          // Visits (seguimientos)
          try {
            const { dataGridSeguimientos } = await import('@/apiDataGrids');
            const { count } = await dataGridSeguimientos(this, filtersCommon, 1, "");
            this.visitsCount = count ? count : 0;
          } catch (e) {
            console.error('Error cargando visitas', e);
          }

          await Promise.all([
            this.fetchProspectsBySeller(filtersCommon),
            this.fetchOpportunitiesBySeller(filtersCommon),
            this.fetchSalesFunnel(filtersCommon)
          ]);
        } catch (err) {
          console.error(err);
        }
      },
      async fetchOpportunitiesBySeller() {
        this.loadingOpportunitiesBySeller = true;

        try {
          const parameters = { 
            "Fecha_Inicial": this.startDate,
            "Fecha_Final": this.endDate,
            "Tipo_Reporte": "RT"
          };
          const data = await dataOportunidades(this, 1, "", parameters);
          this.oppportunitiesBySeller = data.map(item => ({
            label: item.Personal || 'Sin comercial',
            value: item.Cantidad ? item.Cantidad : 0
          }));




          console.log(data);
          

          // return {
          //   label: seller.label || 'Sin comercial',
          //   value: count ? count : 0
          // };
        } catch (error) {
          console.log(error);
          
          // return {
          //   label: seller.label || 'Sin comercial',
          //   value: 0
          // };

          // console.error('Error cargando oportunidades por comercial', error);
          // this.opportunitiesBySeller = [];
          // this.destroyOpportunitiesBySellerChart();
        } finally {
          this.loadingOpportunitiesBySeller = false;
        }
      },

      async loadFilterOptions() {
        try {
          const { dataListGruposOportunidades } = await import("@/api");
          const groups = await dataListGruposOportunidades(this);
          this.groupOptions = [ { value: '', label: 'Todos' }, ...groups.map(g => ({ value: g.id_GrupoOportunidad, label: g.grupo_Oportunidad })) ];
        } catch (e) {
          console.error('Error cargando grupos', e);
        }

        try {
          const { dataListFasesVentas } = await import('@/api');
          const phases = await dataListFasesVentas(this);
          this.salesPhaseOptions = (phases || []).map(phase => ({
            value: phase.id_FaseVenta,
            label: phase.fase_Venta
          }));
        } catch (e) {
          console.error('Error cargando fases de venta', e);
        }

        try {
          const { dataGridVendedores } = await import('@/apiDataGrids');
          const { count, results } = await dataGridVendedores(this, 1, "");
          let sellers = results || [];

          if (count && sellers.length && count > sellers.length) {
            const pageCount = Math.ceil(count / sellers.length);
            const extraPages = await Promise.all(
              Array.from({ length: pageCount - 1 }, (_, index) => dataGridVendedores(this, index + 2, ""))
            );

            sellers = sellers.concat(...extraPages.map(page => page.results || []));
          }

          this.sellerOptions = [ { value: '', label: 'Todos' }, ...sellers.map(s => ({ value: s.id_Personal || s.id_Empleado, label: s.nombre_Empleado || s.nombre })) ];
        } catch (e) {
          console.error('Error cargando vendedores', e);
        }
      },
      async fetchCountsWithFilters() {
        await this.fetchCounts(true);
      },
      getFiltersCommon(useFilters = false) {
        const start = useFilters && this.startDate ? this.startDate : moment().startOf('month').format('YYYY-MM-DD');
        const end = useFilters && this.endDate ? this.endDate : moment().endOf('month').format('YYYY-MM-DD');
        const filtersCommon = {
          Fecha_Inicial: start,
          Fecha_Final: end
        };

        if (this.selectedGroup) filtersCommon.Id_GrupoPersonal = this.selectedGroup;
        if (this.selectedSeller) filtersCommon.Id_Empleado = this.selectedSeller;

        return filtersCommon;
      },
      getSelectedSellers() {
        return this.selectedSeller
          ? this.sellerOptions.filter(seller => `${seller.value}` === `${this.selectedSeller}`)
          : this.sellerOptions.filter(seller => seller.value);
      },
      async fetchProspectsBySeller(filtersCommon) {
        this.loadingProspectsBySeller = true;

        try {
          const { dataGridDirectorio } = await import('@/api');
          const sellers = this.getSelectedSellers();

          const prospectsBySeller = await Promise.all(
            sellers.map(async (seller) => {
              try {
                const { count } = await dataGridDirectorio(this, 1, "", {
                  tipo: "prospecto",
                  ...filtersCommon,
                  Id_Empleado: seller.value
                });

                return {
                  label: seller.label || 'Sin comercial',
                  value: count ? count : 0
                };
              } catch (error) {
                console.error(`Error cargando prospectos de ${seller.label}`, error);
                return {
                  label: seller.label || 'Sin comercial',
                  value: 0
                };
              }
            })
          );

          this.prospectsBySeller = prospectsBySeller
            .filter(item => item.value > 0)
            .sort((a, b) => b.value - a.value);

          this.$nextTick(this.renderProspectsBySellerChart);
        } catch (error) {
          console.error('Error cargando prospectos por comercial', error);
          this.prospectsBySeller = [];
          this.destroyProspectsBySellerChart();
        } finally {
          this.loadingProspectsBySeller = false;
        }
      },
      async fetchSalesFunnel(filtersCommon) {
        this.loadingSalesFunnel = true;

        try {
          const { dataGridOportunidades } = await import('@/api');
          const salesFunnelData = await Promise.all(
            this.salesPhaseOptions.map(async (phase) => {
              try {
                const { count } = await dataGridOportunidades(this, 1, "", {
                  ...filtersCommon,
                  Id_FaseVenta: phase.value
                });

                return {
                  label: phase.label || 'Sin fase',
                  value: count ? count : 0
                };
              } catch (error) {
                console.error(`Error cargando oportunidades de fase ${phase.label}`, error);
                return {
                  label: phase.label || 'Sin fase',
                  value: 0
                };
              }
            })
          );

          this.salesFunnelData = salesFunnelData.filter(item => item.value > 0);
          this.$nextTick(this.renderSalesFunnelChart);
        } catch (error) {
          console.error('Error cargando funnel de ventas', error);
          this.salesFunnelData = [];
          this.destroySalesFunnelChart();
        } finally {
          this.loadingSalesFunnel = false;
        }
      },
      destroyProspectsBySellerChart() {
        if (this.prospectsBySellerChart) {
          this.prospectsBySellerChart.destroy();
          this.prospectsBySellerChart = null;
        }
      },
      destroyOpportunitiesBySellerChart() {
        if (this.opportunitiesBySellerChart) {
          this.opportunitiesBySellerChart.destroy();
          this.opportunitiesBySellerChart = null;
        }
      },
      destroySalesFunnelChart() {
        if (this.salesFunnelChart) {
          this.salesFunnelChart.destroy();
          this.salesFunnelChart = null;
        }
      },
      renderProspectsBySellerChart() {
        this.destroyProspectsBySellerChart();

        if (!this.prospectsBySeller.length || !this.$refs.prospectsBySellerChart) return;

        this.prospectsBySellerChart = new Chart(this.$refs.prospectsBySellerChart, {
          type: "pie",
          data: {
            labels: this.prospectsBySeller.map(item => item.label),
            datasets: [
              {
                data: this.prospectsBySeller.map(item => item.value),
                backgroundColor: this.prospectsBySeller.map((_, index) => this.chartColors[index % this.chartColors.length]),
                borderColor: "#ffffff",
                borderWidth: 2
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: true,
                position: "right",
                labels: {
                  boxWidth: 10,
                  boxHeight: 10,
                  padding: 14,
                  font: {
                    size: 11
                  }
                }
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const total = this.prospectsBySeller.reduce((sum, item) => sum + item.value, 0);
                    const value = context.parsed || 0;
                    const percentage = total ? ((value * 100) / total).toFixed(1) : 0;
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              },
              datalabels: {
                color: "#ffffff",
                font: {
                  size: 11,
                  weight: "bold"
                },
                formatter: (value) => {
                  const total = this.prospectsBySeller.reduce((sum, item) => sum + item.value, 0);
                  const percentage = total ? ((value * 100) / total) : 0;

                  return percentage >= 5 ? `${percentage.toFixed(0)}%` : "";
                }
              }
            }
          },
          plugins: [ChartDataLabels]
        });
      },
      renderOpportunitiesBySellerChart() {
        this.destroyOpportunitiesBySellerChart();

        if (!this.opportunitiesBySeller.length || !this.$refs.opportunitiesBySellerChart) return;

        this.opportunitiesBySellerChart = new Chart(this.$refs.opportunitiesBySellerChart, {
          type: "pie",
          data: {
            labels: this.opportunitiesBySeller.map(item => item.label),
            datasets: [
              {
                data: this.opportunitiesBySeller.map(item => item.value),
                backgroundColor: this.opportunitiesBySeller.map((_, index) => this.chartColors[(index + 1) % this.chartColors.length]),
                borderColor: "#ffffff",
                borderWidth: 2
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: true,
                position: "right",
                labels: {
                  boxWidth: 10,
                  boxHeight: 10,
                  padding: 14,
                  font: {
                    size: 11
                  }
                }
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const total = this.opportunitiesBySeller.reduce((sum, item) => sum + item.value, 0);
                    const value = context.parsed || 0;
                    const percentage = total ? ((value * 100) / total).toFixed(1) : 0;
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              },
              datalabels: {
                color: "#ffffff",
                font: {
                  size: 11,
                  weight: "bold"
                },
                formatter: (value) => {
                  const total = this.opportunitiesBySeller.reduce((sum, item) => sum + item.value, 0);
                  const percentage = total ? ((value * 100) / total) : 0;

                  return percentage >= 5 ? `${percentage.toFixed(0)}%` : "";
                }
              }
            }
          },
          plugins: [ChartDataLabels]
        });
      },
      renderSalesFunnelChart() {
        this.destroySalesFunnelChart();

        if (!this.salesFunnelData.length || !this.$refs.salesFunnelChart) return;

        const total = this.salesFunnelData.reduce((sum, item) => sum + item.value, 0);

        this.salesFunnelChart = new Chart(this.$refs.salesFunnelChart, {
          type: "funnel",
          data: {
            labels: this.salesFunnelData.map(item => item.label),
            datasets: [
              {
                data: this.salesFunnelData.map(item => item.value),
                backgroundColor: this.salesFunnelData.map((_, index) => this.chartColors[(index + 3) % this.chartColors.length]),
                borderColor: "#ffffff",
                borderWidth: 2,
                shrinkAnchor: "top"
              }
            ]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: "y",
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                callbacks: {
                  label: (context) => {
                    const value = context.raw || 0;
                    const percentage = total ? ((value * 100) / total).toFixed(1) : 0;
                    return `${context.label}: ${value} (${percentage}%)`;
                  }
                }
              },
              datalabels: {
                color: "#111827",
                font: {
                  size: 12,
                  weight: "bold"
                },
                formatter: (value, context) => {
                  const label = context.chart.data.labels[context.dataIndex];
                  const percentage = total ? ((value * 100) / total).toFixed(0) : 0;

                  return `${label}\n${value} (${percentage}%)`;
                }
              }
            }
          },
          plugins: [ChartDataLabels]
        });
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath.split("/")[1];

      await this.loadFilterOptions();

      this.startDate = moment().startOf("month").format("YYYY-MM-DD");
      this.endDate = moment().endOf("month").format("YYYY-MM-DD");

      this.fetchCounts();

      this.fetchOpportunitiesBySeller();

      console.log(this.rootPath);
    },
    beforeDestroy() {
      this.destroyProspectsBySellerChart();
      this.destroyOpportunitiesBySellerChart();
      this.destroySalesFunnelChart();
    }
  }
</script>

<style scoped>
  /* Filters */
  .filters-card {
    overflow: hidden;
    border: 0;
    box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
  }

  .filters-card .card-body {
    padding: 1.15rem 1.25rem 1.25rem;
  }

  .filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding-bottom: 0.9rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(148, 163, 184, 0.24);
  }

  .filters-kicker {
    display: block;
    color: #0f766e;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .filters-header h5 {
    margin: 0.1rem 0 0;
    color: #111827;
    font-size: 1.05rem;
    font-weight: 800;
  }

  .filters-range {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    min-height: 2.3rem;
    padding: 0.45rem 0.75rem;
    color: #334155;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(148, 163, 184, 0.3);
    border-radius: 0.5rem;
    font-size: 0.82rem;
    font-weight: 700;
    white-space: nowrap;
  }

  .filters-range i {
    color: #0ea5a5;
    font-size: 1rem;
  }

  .filters-row {
    margin-right: -0.4rem;
    margin-left: -0.4rem;
  }

  .filter-col {
    padding-right: 0.4rem;
    padding-left: 0.4rem;
    margin-bottom: 0.75rem;
  }

  .filters-row .form-group {
    margin-bottom: 0;
  }

  .filter-field,
  .filter-select {
    height: 100%;
  }

  .filter-field label,
  .filter-select >>> label {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    min-height: 1.3rem;
    margin-bottom: 0.35rem;
    color: #475569;
    font-size: 0.78rem;
    font-weight: 800;
  }

  .filter-field label i {
    color: #14b8a6;
    font-size: 0.95rem;
  }

  .filter-control,
  .filter-control >>> input,
  .filter-select >>> select {
    width: 100%;
  }

  .filter-control >>> input,
  .filter-select >>> select {
    min-height: 2.45rem;
    color: #111827;
    background-color: rgba(255, 255, 255, 0.92);
    border: 1px solid #dbe3ea;
    border-radius: 0.5rem;
    font-weight: 700;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    transition: border-color .15s ease, box-shadow .15s ease, background-color .15s ease;
  }

  .filter-control >>> input:focus,
  .filter-select >>> select:focus {
    background-color: #ffffff;
    border-color: #14b8a6;
    box-shadow: 0 0 0 0.18rem rgba(20, 184, 166, 0.16);
  }

  .filters-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
  }

  .query-button {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    min-height: 2.55rem;
    padding: 0.5rem 1rem;
    border: 0;
    border-radius: 0.55rem;
    background: #111827;
    box-shadow: 0 10px 22px rgba(17, 24, 39, 0.18);
    font-weight: 800;
    transition: transform .14s ease, box-shadow .14s ease, background-color .14s ease;
  }

  .query-button:hover,
  .query-button:focus {
    background: #0f766e;
    transform: translateY(-1px);
    box-shadow: 0 14px 28px rgba(15, 118, 110, 0.22);
  }

  .chart-card { border: 0; box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08); }
  .chart-card .card-header { background: #fff; border-bottom: 1px solid #e5e7eb; }
  .chart-shell { height: 320px; position: relative; }
  .funnel-shell { height: 360px; position: relative; }
  .chart-state { min-height: 160px; display: flex; align-items: center; justify-content: center; font-size: 0.95rem; }

  /* Button adjustments */
  .mb-3 .c-button { height: 40px; }

  @media (min-width: 992px) {
    .filter-col { margin-bottom: 0; }
  }

  @media (max-width: 767px) {
    .info-tile { min-width: calc(33% - 8px); padding: 0.75rem; }
    .filters-header { align-items: flex-start; flex-direction: column; }
    .filters-range { width: 100%; justify-content: center; white-space: normal; }
    .filters-actions { margin-top: 0.25rem; }
    .query-button { width: 100%; justify-content: center; }
    .metro-menu .tile { min-width: 46%; }
    .chart-shell { height: 360px; }
    .funnel-shell { height: 420px; }
  }
</style>
